import React from "react"
import Items from "./Items"
import "./ShoppingCart.css"
import CheckSteps from "../CheckSteps"

function ShoppingCart(props) {
  return (
    <div className="ShoppingCart">
      <CheckSteps steps={props.steps} setSteps={props.setSteps} value="cart" />
      <Items {...props} />
      <span className="buttons">
        <button
          className="black"
          type="button"
          onClick={props.proceedToCheckout}
        >
          Proceed to checkout
        </button>
      </span>
    </div>
  )
}

export default ShoppingCart
